import React, { MouseEventHandler } from 'react';
import { Empty } from 'antd';
import CustomCard from '@components/CustomCard';

import * as S from './styles';

interface StatCardInlineProps {
  title: string;
  value?: number;
  onClick?: MouseEventHandler<HTMLElement>;
}

const StatCardInline = ({ title, value, onClick }: StatCardInlineProps) => (
  <CustomCard
    loading={value === undefined}
    onClick={onClick}
    bodyStyle={{
      padding: 16,
      height: '100%',
    }}
    style={{ height: '100%' }}
  >
    {value === undefined ? (
      <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} style={{ height: '100%' }} />
    ) : (
      <S.StatisticStyled>
        <span className="stat-value">{value?.toLocaleString('pt-BR')}</span>
        <span className="stat-text">{title}</span>
      </S.StatisticStyled>
    )}
  </CustomCard>
);

export default StatCardInline;
